import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, Input, message, Modal, Row, Select, Space, Form, Upload } from "antd"
import { useForm } from "antd/lib/form/Form"
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

const { Option } = Select

interface Prop {
    storeID?: string
    onChange: () => void
    checkInRecordData?: checkInRecordData[],
    serviceData?: any
}

interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface ep {
    "employee_id": string,
    "user_name": string
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()
    const [ep26Data, setEp26Data] = useState<ep[]>([])

    useEffect(() => {
        if (prop.storeID) {
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: '26,22'
                }
            }).then((res: any) => {
                res && setEp26Data(res)
            })
        }
    }, [prop.storeID])

    useEffect(() => {
        if (prop.serviceData) {
            console.log(prop.serviceData)

            form.setFieldsValue({

            })
        }
    }, [prop.serviceData])


    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/handle_check_in', {
            check_in_id: param.id,
            pay_detail: reciveMoneyData
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onChange()
            }
        })
    }

    interface reciveRow {
        pay_item: undefined | string, // 付款日期，例如“2021-06-30”
        pay_code: undefined | string, // 收款单号
        pay_way: undefined | number, // 付款方式，1现金 2支付宝 3微信 4银联卡
        pay_amount: undefined | string, // 付款金额，小数类型
        pay_prov_pic_list: undefined | string[], // 付款收据图片集合，上传图片接口返回的图片路径
        pay_operator_id: undefined | string, // 收款操作人，“全局-查询某个组织某个职位的员工列表”接口（注意要传store_id查询）返回的employee_id字段
        remark: undefined | string
    }

    interface ep {
        "employee_id": string,
        "user_name": string
    }

    const upLoadProps = {
        name: 'files',
        data: { fileType: 1, bucketType: 4 },
        action: apiPrefix + '/global/upload_pic',
    }

    let reciveMoneyRow: reciveRow = {
        pay_item: undefined,
        pay_code: undefined,
        pay_way: undefined,
        pay_amount: undefined,
        pay_prov_pic_list: [],
        pay_operator_id: undefined,
        remark: undefined
    }

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([])

    const addMoreRow = () => {
        setReciveMoneyData([...reciveMoneyData, reciveMoneyRow])
    }

    const deleteRow = (index: number) => {
        if (reciveMoneyData.length > 1) {
            let reciveD = _.cloneDeep(reciveMoneyData)
            reciveD.splice(index, 1)

            setReciveMoneyData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)
        reciveD[index][attr] = value

        setReciveMoneyData(reciveD)
    }

    const uploadChange = (info: any, index: number) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)
            reciveD[index].pay_prov_pic_list.push(info.file.response.data[0])

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            let i = reciveD[index].pay_prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
            reciveD[index].pay_prov_pic_list.splice(i, 1)

            setReciveMoneyData(reciveD)
        }
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 办理入住 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>办理入住</Button>

        <Modal title="办理入住" width={1200} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <p style={{ fontWeight: 'bold', fontSize: 16 }}>带红色<span style={{ color: 'red' }}>*</span>号的表单项为必填项，请填写完整再提交表单！</p>

                <Form form={form} style={{ marginTop: 20 }}>
                    {prop.checkInRecordData && prop.checkInRecordData.length > 0 ? <Fragment>
                        <Form.Item label="入住房间" required>
                            <Input disabled value={prop.checkInRecordData && prop.checkInRecordData[0] && prop.checkInRecordData[0].room_number} />
                        </Form.Item>

                        <Row style={{ marginBottom: 16 }} gutter={8} justify="space-around">
                            <Col span={3}>收款项目</Col>
                            <Col span={3}>收款单号</Col>
                            <Col span={3}>收款方式</Col>
                            <Col span={3}>收款金额</Col>
                            <Col span={3}>收款凭证</Col>
                            <Col span={3}>收款人</Col>
                            <Col span={3}>备注</Col>
                            <Col span={1}></Col>
                        </Row>

                        {reciveMoneyData.map((el, index: number) =>
                            <Row gutter={8} justify="space-around" style={{ marginBottom: 8, userSelect: 'none' }}>
                                <Col span={3}>
                                    <Select style={{ width: '100%' }} onChange={(v: any) => {
                                        handleChange(index, 'pay_item', v)
                                    }}>
                                        <Option value={4}>合同尾款</Option>
                                        <Option value={10}>入住押金</Option>
                                    </Select>
                                </Col>
                                <Col span={3}><Input value={el.pay_code} onChange={(v) => {
                                    handleChange(index, 'pay_code', v.target.value)
                                }} /></Col>
                                <Col span={3}>
                                    <Select value={el.pay_way} style={{ width: '100%' }} onChange={(v: number) => {
                                        handleChange(index, 'pay_way', v)
                                    }}>
                                        <Option key={1} value={1}>现金</Option>
                                        <Option key={2} value={2}>支付宝</Option>
                                        <Option key={3} value={3}>微信</Option>
                                        <Option key={4} value={4}>银联卡</Option>
                                        <Option key={6} value={6}>小精灵</Option>
                                        <Option key={7} value={7}>对公转账</Option>
                                    </Select>
                                </Col>
                                <Col span={3}><Input value={el.pay_amount} onChange={(e) => {
                                    handleChange(index, 'pay_amount', e.target.value)
                                }} /></Col>
                                <Col span={3} style={{ paddingTop: 4 }}>
                                    <Space>
                                        <Upload {...upLoadProps} onChange={(info: any) => {
                                            uploadChange(info, index)
                                        }}>
                                            <Button icon={<UploadOutlined />} size="small" ></Button>
                                        </Upload>
                                    </Space>
                                </Col>
                                <Col span={3}>
                                    <Select virtual={false} value={el.pay_operator_id} style={{ width: '100%' }} onChange={(v: string) => {
                                        handleChange(index, 'pay_operator_id', v)
                                    }}>
                                        {ep26Data.map((el: ep) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                                    </Select>
                                </Col>
                                <Col span={3}><Input value={el.remark} onChange={(v) => {
                                    handleChange(index, 'remark', v.target.value)
                                }} /></Col>

                                <Col span={1} style={{ paddingTop: 4 }}>
                                    <DeleteOutlined onClick={() => {
                                        deleteRow(index)
                                    }} style={{ cursor: 'pointer' }} />
                                </Col>
                            </Row>
                        )}

                        <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加收款信息</Button>
                    </Fragment> : null}
                </Form>
            </div>
        </Modal>
    </Fragment>
}